import Joi from 'joi';
const imageGalleryBlockSchema = Joi.object({
  type: Joi.string().valid('imageGalleryBlock').required(),
  code: Joi.string().allow('', null),
  title: Joi.string().allow('', null),
  titleLink: Joi.string().allow('', null),
  backgroundColor: Joi.string().allow('', null),
  images: Joi.array().items(Joi.object({
    id: Joi.string().required(),
    src: Joi.string().required(),
    alt: Joi.string().allow('', null),
    href: Joi.string().allow('', null)
  }).unknown(true)).required()
}).unknown(true);
export default imageGalleryBlockSchema;